import React, { useEffect } from "react";
import auth from "../../services/authService";
import { activity } from "../../services/hrm";
import { Route, Redirect ,useHistory} from "react-router-dom";
import { useIdleTimer } from "react-idle-timer/dist/index.legacy.cjs";

const ProtectedRoute = ({ path, component: Component, render, ...rest }) => {

let page = path.replace('/','')

useEffect(() => {
  if (!page) return;
  const activityPage = async () => {
    const doc ={page: page}
     await activity(doc);
  }
  activityPage() 
}
,[page])

  const history = useHistory();
  const handleOnIdle = () =>{
    onTimeout({page: "timeout"});
    localStorage.clear("tokenhrm");
    history.push("/ideltimeout");
  }
  const onTimeout = async (doc) => {
    const { data: result } = await activity(doc);
    if (result.status === "success") {
    }
  };
useIdleTimer({
    onIdle: handleOnIdle,
    timeout: 1000*60*30,
  });
  return (
    <Route
      {...rest}
      render={props => {
      //  console.log(props);

        if (!auth.getCurrentUser())
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
